import * as React from 'react';
import cn from 'classnames';
import { Currency, CurrencySymbols } from '../../enums';
import { useTheme } from '../../theme';
import { getFormattedAmount } from '../utils';
export var Money = function (_a) {
    var _b;
    var money = _a.money, moneyClassName = _a.moneyClassName, amountClassName = _a.amountClassName, currencyClassName = _a.currencyClassName, _c = _a.multiplyBy, multiplyBy = _c === void 0 ? 1 : _c, amountRenderer = _a.amountRenderer, currencyRenderer = _a.currencyRenderer, _d = _a.showCurrency, showCurrency = _d === void 0 ? true : _d, _e = _a.showCurrencyBeforeAmount, showCurrencyBeforeAmount = _e === void 0 ? false : _e, roundType = _a.roundType;
    var css = useTheme('Money').Money;
    var formattedAmount = React.useMemo(function () { return getFormattedAmount(money, multiplyBy, roundType); }, [
        roundType,
        money,
        multiplyBy
    ]);
    return (React.createElement("span", { className: cn(css.money, moneyClassName) },
        money &&
            showCurrency &&
            showCurrencyBeforeAmount &&
            money.currency !== Currency.USD &&
            (currencyRenderer ? (currencyRenderer(CurrencySymbols.USD)) : (React.createElement("span", { className: cn((_b = {}, _b[css.currency_before] = showCurrencyBeforeAmount, _b), currencyClassName) }, CurrencySymbols[money.currency]))),
        money &&
            showCurrency &&
            !showCurrencyBeforeAmount &&
            money.currency === Currency.USD &&
            (currencyRenderer ? (currencyRenderer(CurrencySymbols.USD)) : (React.createElement("span", { className: currencyClassName }, CurrencySymbols.USD))),
        amountRenderer ? (amountRenderer(money.amount, money.currency)) : (React.createElement("span", { className: amountClassName }, formattedAmount ? formattedAmount : '0')),
        money &&
            showCurrency &&
            !showCurrencyBeforeAmount &&
            money.currency !== Currency.USD &&
            (currencyRenderer ? (currencyRenderer(CurrencySymbols.USD)) : (React.createElement("span", { className: currencyClassName },
                " ",
                CurrencySymbols[money.currency])))));
};
export default Money;
